import { render } from "./Es.vue?vue&type=template&id=49649e51"
import script from "./Es.vue?vue&type=script&lang=js"
export * from "./Es.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-archive/__GITLAB/archive-collections/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__